import * as propertyTypes from "../property_types.js"

export class UiSortableList extends propertyTypes.AppBaseComponentProps {

    private templateMetadata = new propertyTypes.TextProperty("template", "Template");
    public template: string;

    private styleMetadata = new propertyTypes.TextProperty("style", "Style");
    public style: string;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.metadataAll = baseMetaData.concat([this.templateMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }
}